export * from './firebase.app.module';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// C:/React/Antique/~/angularfire2/app/index.js
// module id = ../../../../angularfire2/app/index.js
// module chunks = 3